/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

const spacingAliases: Record<string, number> = {
	noGap: 0,
	sm: 5,
	reg: 10,
	md: 15,
	lg: 20,
	xl: 30,
};

export const customSpacing: ThemeOptions = {
	customSpacing: (key: number | string) => {
		if (typeof key === 'number') return key * 5;
		return spacingAliases[key];
	},
} as ThemeOptions;

export type SpacingKey = 'noGap' | 'sm' | 'reg' | 'md' | 'lg' | 'xl';
